import type {
  IPublishSkillMarketplaceParams,
  ISkillMarketplaceListing,
  IUpdateSkillMarketplacePreferenceParams,
} from "../types/skill-marketplace";
import type { ApiClient } from "./client";

// NOTE: NSAI-7391 — the organization-wide skills marketplace. Browsing and the
// member's own discovery choice need marketplace_skill:read; publishing needs
// marketplace_skill:write plus the server's publisher rule. Every route is
// scoped to the current project through the x-project-uuid header the
// ApiClient already sends.
export class SkillMarketplaceApi {
  constructor(private readonly apiClient: ApiClient) {}

  async getListings(): Promise<ISkillMarketplaceListing[]> {
    const response =
      await this.apiClient.get<ISkillMarketplaceListing[]>(
        "/skill-marketplace",
      );
    return response.data;
  }

  async publish({
    skillUuid,
    data,
  }: IPublishSkillMarketplaceParams): Promise<ISkillMarketplaceListing> {
    const response = await this.apiClient.post<ISkillMarketplaceListing>(
      `/skill-marketplace/${skillUuid}`,
      data,
    );
    return response.data;
  }

  async updateListing({
    skillUuid,
    data,
  }: IPublishSkillMarketplaceParams): Promise<ISkillMarketplaceListing> {
    const response = await this.apiClient.put<ISkillMarketplaceListing>(
      `/skill-marketplace/${skillUuid}`,
      data,
    );
    return response.data;
  }

  async unpublish(skillUuid: string): Promise<void> {
    await this.apiClient.delete(`/skill-marketplace/${skillUuid}`);
  }

  async updatePreference({
    listingUuid,
    isEnabled,
  }: IUpdateSkillMarketplacePreferenceParams): Promise<ISkillMarketplaceListing> {
    const response = await this.apiClient.put<ISkillMarketplaceListing>(
      `/skill-marketplace/listings/${listingUuid}/preference`,
      { isEnabled },
    );
    return response.data;
  }
}
